import { FC } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

const menuItems = [
  { path: '/organizations', label: 'Organizations' },
  { path: '/subscription-periods', label: 'Subscription Periods' },
  { path: '/users', label: 'Users' },
];

export const Layout: FC = () => {
  const location = useLocation();
  const auth = useAuth();

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Side Menu */}
      <div className="w-64 bg-white shadow-lg">
        <div className="p-4">
          <h2 className="text-xl font-semibold">play-avatar: admin</h2>
        </div>
        <nav className="mt-10">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`block px-4 py-2 text-sm font-bold ${
                location.pathname.startsWith(item.path)
                  ? 'bg-blue-50 text-blue-600'
                  : 'text-black hover:bg-gray-50'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="absolute bottom-0 w-64 pb-4">
          <button
            onClick={() => auth.signoutRedirect()}
            className="w-full font-bold py-2 text-sm hover:bg-gray-50 text-left p-4 cursor-pointer"
          >
            Sign Out
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
        <div className="p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}; 